// extracted by mini-css-extract-plugin
module.exports = {"form":"QuoteModal_form__1wzgf","error":"QuoteModal_error__29NWB","actions":"QuoteModal_actions__3iyYD"};